<template>
  <div>
    <el-card class="box-card" body-style="min-height:90vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础信息" name="first">
          <system></system>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second">
          <change-pwd></change-pwd>
        </el-tab-pane>
        <el-tab-pane label="自提点配置" name="third">
          <pickup></pickup>
        </el-tab-pane>
        <el-tab-pane label="退货配置" name="forth">
          <refund></refund>
        </el-tab-pane>
        <el-tab-pane label="核销配置" name="fifth">
          <write-off></write-off>
        </el-tab-pane>
        <el-tab-pane label="微信支付配置" name="sixed">
          <wx-pay></wx-pay>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import System from './components/JourneySystem.vue'
import ChangePwd from './components/ChangePwd.vue'
import Pickup from './components/JourneyPickup.vue'
import Refund from './components/Refund.vue'
import WriteOff from './components/JourneyWriteOff.vue'
import WxPay from './components/JourneyWxPay.vue'
export default {
  name: 'JourneySetting',
  components: {
    System,
    ChangePwd,
    Pickup,
    Refund,
    WriteOff,
    WxPay
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:1
    }
  },
  mounted () {
    var that = this;
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
      if(tab.name === 'first'){
        this.activeNum = 1
      }else if(tab.name === 'second'){
        this.activeNum = 0
      }else if(tab.name === 'third'){
        this.activeNum = 2
      }else if(tab.name === 'forth'){
        this.activeNum = 3
      }else{
        this.activeNum = 4
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/JourneySetting.vue